import { render } from "./StageManagement.vue?vue&type=template&id=c9c85c1a&scoped=true"
import script from "./StageManagement.vue?vue&type=script&lang=js"
export * from "./StageManagement.vue?vue&type=script&lang=js"

import "./StageManagement.vue?vue&type=style&index=0&id=c9c85c1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9c85c1a"]])

export default __exports__